<script setup>
import { ref, reactive, computed, onMounted, nextTick, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { Loading } from 'element-ui'
import { lockTask, findTaskDetailById, execTaskItemH5, submitTask,
        getCorrectProcessor, addCorrectInTir, deleteCorrectById } from '../../api/request'
import TaskItem from '../task/component/taskItem.vue'
import SeeRoutDetail from '../DetailPages/details/seeRoutDetail.vue'
import { traverseEmi, CheckItems, getUploadUrl, hasImage, hasVideo } from './tools'
import UploadFiles from '../../components/UploadFiles'
import { ResourceUploadConfig } from '../course/js/const'
import { removeItemByProp } from '../../libs/tools'
import { successMsg } from '../../utils/message'

const route = useRoute()
const router = useRouter()
const taskRecord = reactive({
  id: '',
  name: '',
  corLimit: 0,
  reportShowType: 1,
  ttId: ''
})
const cpList = ref([])
const lockResult = reactive({})
const rootMajorItems = ref([])
const endMajorItems = ref([])
const currentMajorItems = ref([])
const majorItemMenuDom = ref(null)
const currentEndMajorItem = ref('')
const subpage = reactive({
  previewVisible: false,
  undoneItemsIndex: 0,
  undoneItemsTitle: '',
  undoneItemsVisible: false,
  undoneItems: [],
  tirOrigin: 0,
  currentTir: null,
  dialogueType: 1, //1备注 2媒体 3整改
  dialogueTitle: '',
  dialogueVisible: false,
  commentValue: '',
  imageList: [],
  videoList: [],
  correctList: []
})
const dialogFormRef = ref(null)

const uploadUrl = computed(() => getUploadUrl(taskRecord.ttId))

onMounted(() => {
  if (route.params.trId) {
    taskRecord.id = route.params.trId
    taskRecord.name = route.params.taskName
    _lock()
  }
})

onBeforeUnmount(() => lockResult.success && lockTask(taskRecord.id, 2))

function _goBack() {
  router.go(-1)
}

async function _lock() {
  let loadingInstance = Loading.service()
  Object.assign(lockResult, await lockTask(taskRecord.id, 1))
  if (lockResult.success) await _getData(loadingInstance)
  else loadingInstance.close()
}

async function _getData(loadingInstance) {
  if (!loadingInstance) loadingInstance = Loading.service()
  rootMajorItems.value.splice(0, rootMajorItems.value.length)
  endMajorItems.value.splice(0, endMajorItems.value.length)
  currentMajorItems.value.splice(0, currentMajorItems.value.length)
  subpage.undoneItems.splice(0, subpage.undoneItems.length)
  let res = await findTaskDetailById(taskRecord.id)
  if (res && res.data) {
    taskRecord.corLimit = res.data.corLimit
    if (taskRecord.corLimit === 1) {
      cpList.value.splice(0, cpList.value.length)
      let cpRes = await getCorrectProcessor(taskRecord.id)
      cpRes && Array.isArray(cpRes.data) && cpRes.data.forEach(cp => cpList.value.push(cp))
    }
    taskRecord.reportShowType = res.data.reportShowType
    taskRecord.ttId = res.data.taskTemplateId
    if (Array.isArray(res.data.taskGroupModels)) {
      res.data.taskGroupModels.forEach(mi =>
        rootMajorItems.value.push({
          id: mi.id,
          name: mi.name,
          isEndGroup: mi.isEndGroup,
          childrenNumber:
            Array.isArray(mi.childTaskGroupDtos) ? mi.childTaskGroupDtos.length : 0
        }))
      traverseEmi(res.data.taskGroupModels, _pushEmi)
      await nextTick()
      if (Number.isInteger(subpage.undoneItemsIndex) && subpage.undoneItemsIndex > 0) {
        _showUndoneItems()
      } else {
        majorItemMenuDom.value
          && Array.isArray(majorItemMenuDom.value.$children)
          && majorItemMenuDom.value.$children.length
          && majorItemMenuDom.value.$children[0].$el.click()
      }
    }
  }
  loadingInstance.close()
}

function _pushEmi(mi) {
  Array.isArray(mi.assessItem) && mi.assessItem.forEach(tir => {
    tir.originalState = tir.state
    tir.hasMedia = hasImage(tir) || hasVideo(tir)
  })
  endMajorItems.value.push(mi)
}

function _loadCurrentMajorItems(rmiId) {
  currentMajorItems.value.splice(0, currentMajorItems.value.length)
  endMajorItems.value.forEach(emi => {
      if (emi.id === rmiId || emi.parentId === rmiId || emi.rootNodeId === rmiId) {
        currentMajorItems.value.push(emi)
      }
    })
  nextTick(() => currentEndMajorItem.value = '0')
}

async function _submitTir(tir) {
  let ret = false
  if (tir && tir.id) {
    let loadingInstance = Loading.service({
      target: subpage.undoneItemsVisible ? 'div.undone-items-box' : (
              subpage.dialogueVisible ? 'form.tir-dialogue-container' :
              document.body)
    })
    tir.taskItemRecordId = tir.id
    let res = await execTaskItemH5(taskRecord.id, [tir])
    if (res.success) {
      ret = true
      if (tir.state !== tir.originalState) {
        let cmi = endMajorItems.value.find(mi => mi.id === tir.taskGroupRecordId)          
        if (cmi) {
          if (tir.state > tir.originalState && cmi.finishedTaskNo < cmi.taskItemCount)
            cmi.finishedTaskNo++
          else if (tir.state < tir.originalState && cmi.finishedTaskNo > 0)
            cmi.finishedTaskNo--
        }
      }
    }
    loadingInstance.close()
  }
  return ret
}

function _previewClose(index) {
  subpage.undoneItemsIndex = index
  subpage.previewVisible = false
}

function _handlePreviewClosed() {
  subpage.undoneItemsIndex >= 0 ? _getData() : _submitTask()
}

function _showUndoneItems() {
  subpage.undoneItemsTitle = CheckItems[subpage.undoneItemsIndex].text
  endMajorItems.value.flatMap(emi => emi.assessItem)
        .forEach(tir => CheckItems[subpage.undoneItemsIndex].boolFun(tir) && subpage.undoneItems.push(tir))
        subpage.undoneItemsVisible = true
}

function _submitTask() {
  let loadingInstance = Loading.service()
  submitTask(taskRecord.id).then(res => {
    if (res.success) {
      successMsg('巡检任务提交成功')
      _goBack()
    }
  }).finally(() => loadingInstance.close())
}


function _showDialogueFromMain(tir, type) {
  subpage.tirOrigin = 0
  _showDialogue(tir, type)
}
async function _showDialogueFromSub(tir, type) {
  subpage.tirOrigin = 1
  subpage.undoneItemsVisible = false
  await nextTick()
  _showDialogue(tir, type)
}
async function _showDialogue(tir, type) {
  if (tir && Number.isInteger(type)) {
    subpage.dialogueType = type
    if (subpage.dialogueType === 1) {
      subpage.dialogueTitle = '填写备注'
    } else if (subpage.dialogueType === 2) {
      subpage.dialogueTitle = '上传媒体文件'
    } else if (subpage.dialogueType === 3) {
      subpage.dialogueTitle = '创建整改'
    }
    if (!subpage.currentTir || subpage.currentTir.id !== tir.id) {
      subpage.commentValue = tir.comment
      subpage.imageList.splice(0,subpage.imageList.length)
      hasImage(tir) && tir.images.forEach(url => subpage.imageList.push({ url }))
      subpage.videoList.splice(0,subpage.videoList.length)
      hasVideo(tir) && tir.videos.forEach(v => 
        subpage.videoList.push({ videoUrl: v.url, thumbnail: v.thumbnail, url: v.thumbnail || v.url }))
      
      subpage.correctList.splice(0,subpage.correctList.length)
      if (tir.hasCorrect && Array.isArray(tir.correctDetails) && tir.correctDetails.length) {
        tir.correctDetails.forEach(c => {
          c.userIds = []
          c.processors.forEach(p => c.userIds.push(p.id))
          subpage.correctList.push(Object.assign({}, c))
        })
      } else {
        _addNewCorrect()
      }
    }
    subpage.currentTir = tir
    await nextTick()
    dialogFormRef.value && dialogFormRef.value.clearValidate()
    subpage.dialogueVisible = true
  }
}

async function _submitDialogue() {
  if (subpage.currentTir) {
    if ([1,2].includes(subpage.dialogueType)) {
      subpage.currentTir.state = 1
      if (subpage.dialogueType === 1) {
        subpage.currentTir.comment = subpage.commentValue
      } else if (subpage.dialogueType === 2) {
        subpage.currentTir.images = []
        subpage.currentTir.videos = []
        subpage.currentTir.hasMedia = !!(subpage.imageList.length || subpage.videoList.length)
        subpage.imageList.length &&
            subpage.imageList.forEach(i => subpage.currentTir.images.push(i.url))
        subpage.videoList.length &&
            subpage.videoList.forEach(v => subpage.currentTir.videos.push({ url: v.videoUrl, thumbnail: v.thumbnail }))
      }
      if (await _submitTir(subpage.currentTir))
        subpage.dialogueVisible = false
    } else if (subpage.dialogueType === 3) {
      dialogFormRef.value.validate(valid => {
        if (valid) {
          _submitCorrects()
        } else {
          return false
        }
      })
    }
  }
}
function _handleDialogueClosed() {
  if (subpage.tirOrigin)
    subpage.undoneItemsVisible = true
}

function _uploadImageSuccess(data) {
  subpage.imageList.push({ url: data.url, uid: data.uid })
}
function _removeImage(file) {
  removeItemByProp(subpage.imageList,file,'uid')
}
function _uploadVideoSuccess(data) {
  subpage.videoList.push({ videoUrl: data.url, thumbnail: data.thumbnail, url: data.thumbnail || data.url, uid: data.uid })
}
function _removeVideo(file) {
  removeItemByProp(subpage.videoList,file,'uid')
}

function _addNewCorrect() {
  subpage.correctList.push({
      corDemand: '',
      corRecdId: '',
      deadline: '',
      userIds: []
    })
}
function _submitCorrects() {
  let loadingInstance = Loading.service({ target: 'form.tir-dialogue-container' })
  addCorrectInTir({
    taskRecdId: taskRecord.id,
    taskItemRecdId: subpage.currentTir.id,
    items: subpage.correctList
  }).then(res => {
    if (res.success) {
      subpage.currentTir.correctDetails = []
      subpage.currentTir.hasCorrect = subpage.correctList.length > 0
      Array.isArray(res.data) && subpage.correctList.forEach((c,i) => {
        c.processors = []
        c.userIds.forEach(id => c.processors.push({ id }))
        if (!c.corRecdId && res.data[i])
          c.corRecdId = res.data[i]
        subpage.currentTir.correctDetails.push(c)
      })
      subpage.dialogueVisible = false
    }
  }).finally(() => loadingInstance.close())
}
async function _deleteCorrect(i) {
  if (subpage.correctList[i] && subpage.correctList[i].corRecdId) {
    let loadingInstance = Loading.service({ target: 'form.tir-dialogue-container' })
    await deleteCorrectById(subpage.correctList[i].corRecdId)
    loadingInstance.close()
  }
  subpage.correctList.splice(i,1)
  if (!subpage.correctList.length || subpage.correctList.every(c => !c.corRecdId)) {
    subpage.currentTir.hasCorrect = false
  }
  !subpage.correctList.length && _addNewCorrect()
}
</script>
<template>
<div>
<el-container class="assessment-task-container">
  <el-header class="flex-between-center">
    <el-page-header @back="_goBack" :content="taskRecord.name"></el-page-header>
    <el-button v-if="rootMajorItems.length" type="text" @click="subpage.previewVisible=true"
      style="font-size: 16px; font-weight: bold;">预览</el-button>
  </el-header>
  <el-container v-if="rootMajorItems.length" class="assessment-task-body">
    <el-aside class="body-height" width="25%">
      <el-menu ref="majorItemMenuDom">
        <el-divider>一级分类</el-divider>
        <el-menu-item class="flex-between-center"
          v-for="(rmi, index) in rootMajorItems"
          :key="rmi.id"
          :index="index.toString()"
          @click="_loadCurrentMajorItems(rmi.id)">
          <el-tooltip :content="rmi.name" effect="light" :enterable="false" :hide-after="5000">
            <span class="ellipsis">
              <i class="nonterminal"></i>
              {{ rmi.name }}
            </span>
          </el-tooltip>
          <el-tag size="mini" effect="plain">{{ rmi.childrenNumber ? rmi.childrenNumber : 0 }}</el-tag>
        </el-menu-item>
      </el-menu>
      
    </el-aside>
    <el-main class="body-height">
      <el-collapse v-model="currentEndMajorItem" accordion>
        <el-collapse-item class="end-major-item" v-for="(cmi, index) in currentMajorItems" :key="cmi.id" :name="index.toString()">
          <template slot="title">
            <div class="cmi-title flex-between">
              <div class="cmi-name ellipsis">
                <i class="terminal"></i>
                <span>{{ cmi.name }}</span>
              </div>
              <div class="cmi-count">
                <span class="blue">{{ cmi.finishedTaskNo }}</span>
                <span class="grey"> / {{ cmi.taskItemCount }}</span>
              </div>
            </div>
          </template>
          <TaskItem
            v-if="Array.isArray(cmi.assessItem)"
            v-for="(taskItem, index) in cmi.assessItem"
            :key="taskItem.id"
            :index="index"
            class="assess-item"
            :taskItem="taskItem"
            :corLimit="taskRecord.corLimit"
            @changeItem="_submitTir"
            @showDialogue="_showDialogueFromMain"
          />
        </el-collapse-item>
      </el-collapse>
    </el-main>
  </el-container>
</el-container>
<el-dialog
    title="评估报告预览"
    :visible.sync="subpage.previewVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="_handlePreviewClosed"
    class="dialog-web-page"
    top="2vh">
    <SeeRoutDetail
      :recordId="taskRecord.id"
      :reportShowType="taskRecord.reportShowType"
      :corLimit="taskRecord.corLimit"
      :refresh="subpage.previewVisible"
      @previewClose="_previewClose"/>
</el-dialog>
<el-dialog
    :title="subpage.undoneItemsTitle"
    :visible.sync="subpage.undoneItemsVisible"
    top="4vh"
    @close="subpage.undoneItemsIndex = 0">
    <div class="undone-items-box">
      <TaskItem
        v-for="(taskItem, index) in subpage.undoneItems"
        :key="taskItem.id"
        :index="index"
        class="assess-item"
        :taskItem="taskItem"
        :corLimit="taskRecord.corLimit"
        @changeItem="_submitTir"
        @showDialogue="_showDialogueFromSub"
      />
    </div>
</el-dialog>
<el-dialog
    :visible.sync="subpage.dialogueVisible"
    @close="_handleDialogueClosed">
    <div slot="title">
      <span class="el-dialog__title">{{ subpage.dialogueTitle }}</span>
    </div>
    <el-form class="tir-dialogue-container" :model="subpage" ref="dialogFormRef">
      <el-input v-if="subpage.dialogueType === 1"
        type="textarea"
        placeholder="请填写备注"
        v-model="subpage.commentValue"
        :autosize="{ minRows: 5, maxRows: 10 }"
        maxlength="2000"
        show-word-limit/>
      <div v-if="subpage.dialogueType === 2">
        <el-divider>图片</el-divider>
        <UploadFiles
          :action="uploadUrl"
          listType="picture-card"
          :fileList="subpage.imageList"
          :limit="9"
          :accept="ResourceUploadConfig[1].accept"
          :sizeLimit="ResourceUploadConfig[1].sizeLimit"
          @upload-success="_uploadImageSuccess"
          @file-remove="_removeImage"/>
        <el-divider>视频</el-divider>
        <UploadFiles
          :action="uploadUrl"
          listType="picture-card"
          :fileList="subpage.videoList"
          :limit="1"
          :accept="ResourceUploadConfig[2].accept"
          :sizeLimit="ResourceUploadConfig[2].sizeLimit"
          @upload-success="_uploadVideoSuccess"
          @file-remove="_removeVideo"/>
      </div>
      <template v-if="subpage.dialogueType === 3">
        <el-card v-for="(c,i) in subpage.correctList" :key="i" class="mb20 correct-item" shadow="never">
          <div slot="header" class="flex-between-center">
            <span class="fs16">{{ `整改${i+1}` }}</span>
            <div>
              <el-button v-if="subpage.correctList.length < 5 && i === subpage.correctList.length - 1"
                type="primary" icon="el-icon-plus" circle size="mini" @click="_addNewCorrect"></el-button>
              <el-button v-if="subpage.correctList.length > 1 || c.corRecdId"
                type="danger" icon="el-icon-delete" circle size="mini" @click="_deleteCorrect(i)"></el-button>
            </div>
          </div>
          <el-form-item label="受理人" label-width="80px"
            :prop="`correctList[${i}].userIds`" :rules="[{required: true, message: '受理人不能为空', trigger: 'change'}]">
            <el-select v-model="c.userIds" multiple :clearable="true" :filterable="true" placeholder="请选择受理人">
              <el-option
                v-for="cp in cpList"
                :key="cp.id"
                :label="cp.name"
                :value="cp.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="截止时间" label-width="80px"
            :prop="`correctList[${i}].deadline`" :rules="[{required: true, message: '截止时间不能为空', trigger: 'change'}]">
            <el-date-picker
              v-model="c.deadline"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="请选择截止时间"/>
          </el-form-item>
          <el-form-item>
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
              placeholder="请输入整改内容(非必填)"
              v-model="c.corDemand"/>
          </el-form-item>
        </el-card>
      </template>
      <div class="text_center mt1e">
        <el-button round @click="subpage.dialogueVisible = false">取消</el-button>
        <el-button type="primary" round @click="_submitDialogue">提交</el-button>
      </div>
    </el-form>
</el-dialog>
</div>

</template>

<style lang="less">
.assessment-task-container {
  width: 100%;
  .el-header {
    background-color: #CCD9E8;
    line-height: 60px;
    .el-page-header {
      .el-page-header__left {
        color: #4682B4;
      }
      .el-page-header__left::after {
        background-color: #4682B4;
      }
      .el-page-header__content {
        color: #607B8B;
      }
    }
  }
  .assessment-task-body {
    width: 85%;
    margin: 0 auto;
    background-color: rgb(250, 252, 255);
    .el-aside {
      border-right: 1px solid;
      border-image: linear-gradient(to bottom, transparent, 25%, #CCD9E8, 75%, transparent) 1;
      .el-menu {
        background-color: rgb(250, 252, 255);
        .el-divider {
          .el-divider__text {
            background-color: rgb(250, 252, 255);
          }
        }
        .el-menu-item {
          font-size: 16px;
          height: 64px;
          line-height: 64px;
          padding-left: 20px !important;
          span {
            color: #607B8B;
          }
        }
        .el-menu-item.is-active {
          span {
            color: #4682B4;
            font-weight: bold;
          }
        }
        .el-menu-item:focus, .el-menu-item:hover {
          outline: none;
          background-color: #ecf5ff;
        }
      }
    }
    .el-main {
      height: calc(100vh - 60px);
      padding: 24px;
      .end-major-item {
        .el-collapse-item__header {
          padding: 0 .5em;
          .cmi-title {
            width: 96%;
            .cmi-name {
              font-size: 1rem;
            }
            .cmi-count {
              font-size: .8rem;
            }
          }
        }
        .el-collapse-item__wrap {
          padding: 0 2em;
        }
      }
    }
  }
}

.assess-item {
  margin-bottom: .7em;
  min-height: 5em;
}

.undone-items-box, .tir-dialogue-container {
  margin-top: -20px;
}

.body-height {
  height: calc(100vh - 60px);
}

.el-divider {
  background-color: transparent;
  background-image: linear-gradient(to right, transparent, #CCD9E8, transparent);
  .el-divider__text {
    color: #C0C0C0;
  }
}

.nonterminal {
  &::before {
    content: "";
    display: inline-block;
    height: 18px;
    width: 18px;
    position: relative;
    top: 1px;
    left: 0px;
    background: url("../../assets/image/task/feimoduan.png") no-repeat;
    background-size: 100% 100%;
  }
}
.terminal {
  &::before {
    content: "";
    display: inline-block;
    height: 18px;
    width: 18px;
    position: relative;
    top: 3px;
    left: 0px;
    background: url("../../assets/image/task/moduan.png") no-repeat;
    background-size: 100%;
  }
}

.el-tooltip__popper.is-light {
  color: #607B8B;
  border-color: #b3d8ff;
}
.el-tooltip__popper.is-light[x-placement^="top"] .popper__arrow {
  border-top-color: #b3d8ff;
}
.el-tooltip__popper.is-light[x-placement^="right"] .popper__arrow {
  border-right-color: #b3d8ff;
}
.el-tooltip__popper.is-light[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #b3d8ff;
}
.el-tooltip__popper.is-light[x-placement^="left"] .popper__arrow {
  border-left-color: #b3d8ff;
}

.correct-item {
  .el-select, .el-date-editor.el-input {
    width: 280px;
  }
}
</style>